export const parseDateParts = (dateStr: string) => {
	const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
	return { year, month: month - 1, day };
};

export const formatDateBR = (dateStr: string) => {
	const { year, month, day } = parseDateParts(dateStr);
	const date = new Date(year, month, day);
	return date.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: '2-digit',
	});
};

export const getEventDay = (dateStr: string) => {
	const { day } = parseDateParts(dateStr);
	return day;
};

export const getMonthNumber = (monthName: string): number => {
	const months: { [key: string]: number } = {
		Janeiro: 0,
		Fevereiro: 1,
		Março: 2,
		Abril: 3,
		Maio: 4,
		Junho: 5,
		Julho: 6,
		Agosto: 7,
		Setembro: 8,
		Outubro: 9,
		Novembro: 10,
		Dezembro: 11,
	};
	return months[monthName] ?? 0;
};

export const formatShortWeekday = (_locale: string | undefined, date: Date) => {
	const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
	return days[date.getDay()];
};

export const formatDateString = (date: Date): string => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const getEventDateString = (eventDate: string): string => {
	return eventDate.includes('T') ? eventDate.split('T')[0] : eventDate;
};

export const isDateInPeriod = (dateStr: string, start: string, end: string) => {
	return {
		isStart: dateStr === start,
		isEnd: dateStr === end,
		isMiddle: dateStr > start && dateStr < end,
	};
};

export const hasEventOnDate = (events: Array<{ date: string }>, dateStr: string): boolean => {
	return events.some((event) => {
		const eventDateStr = getEventDateString(event.date);
		return eventDateStr === dateStr;
	});
};
